var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gif-player-container" }, [
    _c("video", {
      ref: "videoElement",
      staticClass: "gif-player",
      attrs: {
        src: _vm.src,
        autoplay: _vm.autoplay,
        loop: _vm.loop,
        controls: _vm.controls,
        poster: _vm.poster,
      },
      domProps: { muted: _vm.muted },
      on: { click: _vm.togglePlay },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "gif-label" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("message.mediaBadgeGif")))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "fullscreen-button",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.openFullscreen.apply(null, arguments)
          },
        },
      },
      [_c("span", { staticClass: "material-icons" }, [_vm._v("open_in_new")])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }